import React from 'react'
import { Checkbox } from 'react-bootstrap'

const workAreasArray = [
    "Staal",
    "Beton",
    "Hout",
    "Overig",
    "Utiliteitsbouw",
    "Industriebouw",
    "Infra/kunstwerken",
    "Funderingstechniek",
    "Hoogbouw",
    "Offshore",
    "Natte waterbouw",
    "Woningbouw"
]
export const getMaterialsWithCheck = (materials, materialsChecked, handleChange) => (materials.map(mat =>
    <Checkbox name="materials" value={parseInt(mat.value)} key={mat.value} defaultChecked={materialsChecked.includes(parseInt(mat.value))} onChange={handleChange}>{mat.label}</Checkbox>
))

export const getWorkAreasWithCheck = (workAreasChecked, handleChange) => (workAreasArray.map((name, i) =>
    <Checkbox name="workAreas[]" value={i + 1} key={i + 1} defaultChecked={workAreasChecked[i]} onChange={handleChange}>{name}</Checkbox>))

export const getWorkAreasWithoutCheck = handleChange => workAreasArray.map((name, i) =>
    <Checkbox name="workAreas[]" value={i + 1} key={i + 1} onChange={handleChange}>{name}</Checkbox>)



// WEBPACK FOOTER //
// ./src/components/Member/Modules/services/arrayServices.js